'use strict';

angular.module('licensure.services')
    .factory('ServiceStations', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();
            
            $http.get(apiLocation + '/api/servicestations', {
                params: args
            })
            .then(function (response) {
                d.resolve(response.data);
            })
            .catch(function (response) {
                console.log(response.data);
                // handle error
            });

            return d.promise;
        }

        var getByID = function (id) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/servicestations/' + id, {
                params: {

                }
            })
            .then(function (response) {
                d.resolve(response.data);
            })
            .catch(function (response) {
                // handle error
            });

            return d.promise;
        }

        return {
            get: get,

            getByID: getByID
        }
    }])
;